import { useEffect } from 'react';

const PageMeta = ({ title, description }) => {
  useEffect(() => {
    // Dynamically update the document title
    document.title = title || 'Phoenix Dental | Best Dentist in Vizag';

    // Find or create the meta description tag
    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.name = 'description';
      document.head.appendChild(metaDescription);
    }
    metaDescription.content = description || 'Top dental clinic in Visakhapatnam offering expert dental care.';
  }, [title, description]);

  return null; // This component doesn't render any visible UI
};

export default PageMeta;
